import { Pipe, PipeTransform } from '@angular/core';
import { ProductSize } from '../../models/organization.model';

@Pipe({
  name: 'priceFromSizes'
})
export class PriceFromSizesPipe implements PipeTransform {

  transform(sizes: ProductSize[], arg: string | null): number {
    switch (arg) {
      case 'min':
        const prices = sizes.map(size => size.price ?? 0);
        return Math.min(...prices);
      case 'first':
        const firstSize = sizes[0];
        return (firstSize && firstSize.price) ? firstSize.price : 0;
      default:
        const foundSize = sizes.find(size => size.id === arg);
        return (foundSize && foundSize.price) ? foundSize.price : 0;
    }
  }

}
